import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import adminAPI from "@/services/api";

/**
 * GET /admin/tenants — Upclaim only. Callers MUST gate with `enabled`,
 * otherwise the server 401s and the axios interceptor toasts the error.
 */
export function useTenants(enabled: boolean) {
  return useQuery({
    queryKey: [...queryKeys.tenant, "list"],
    queryFn: () => adminAPI.listTenants(),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
